import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import reset from 'styled-reset';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

interface IGlobalStyle {
    endpoint: string,
}

export const GlobalStyle = createGlobalStyle<IGlobalStyle>`
    ${reset};
    ${normalize};
    
    :root {
        --bold-h0: 56px/68px CoFoSansBold, Helvetica, sans-serif;
        --bold-h1: 40px/52px CoFoSansBold, Helvetica, sans-serif;
        --bold-h2: 32px/40px CoFoSansBold, Helvetica, sans-serif;
        --bold-h3: 24px/32px CoFoSansBold, Helvetica, sans-serif;
        --bold-h4: 20px/28px CoFoSansBold, Helvetica, sans-serif;
        --bold-h5: 16px/24px CoFoSansMedium, Helvetica, sans-serif;
        --bold-h6: 14px/20px CoFoSansBold, Helvetica, sans-serif;
        --label: 12px/16px CoFoSansBold, Helvetica, sans-serif;
        --label-s: 10px/14px CoFoSansBold, Helvetica, sans-serif;
        --medium: 1em/1.5em CoFoSansMedium, Helvetica, sans-serif;
        --medium-s: 16px/24px CoFoSansMedium, Helvetica, sans-serif;
        --medium-xs: 14px/20px CoFoSansMedium, Helvetica, sans-serif;
        --medium-xxs: 12px/16px CoFoSansMedium, Helvetica, sans-serif;
        --medium-xxxs: 8px/12px CoFoSansMedium, Helvetica, sans-serif;
        --regular-xxl: 24px/40px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xl: 22px/36px CoFoSansRegular, Helvetica, sans-serif;
        --regular-l: 20px/32px CoFoSansRegular, Helvetica, sans-serif;
        --regular-m: 18px/28px CoFoSansRegular, Helvetica, sans-serif;
        --regular-s: 16px/24px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xs: 14px/20px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xxs: 12px/16px CoFoSansRegular, Helvetica, sans-serif;
        --regular-xxxs: 6px/9px CoFoSansRegular, Helvetica, sans-serif;
        --stories: 14px/16px CoFoSansRegular, Helvetica, sans-serif;
        --stories-s: 12px/14px CoFoSansRegular, Helvetica, sans-serif;
    }
    
    @font-face {
        font-family: 'fedraBook';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/FedraSansAltPro-Book.woff'),
        url('${props => props.endpoint}/static/fonts/FedraSansAltPro-Book.ttf'),
        url('${props => props.endpoint}/static/fonts/FedraSansAltPro-Book.woff2');
    }

    @font-face {
        font-family: 'fedraMedium';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/FedraSansAltPro-Medium.woff'),
        url('${props => props.endpoint}/static/fonts/FedraSansAltPro-Medium.ttf'),
        url('${props => props.endpoint}/static/fonts/FedraSansAltPro-Medium.woff2');
    }
    
    @font-face {
        font-family: 'fedraLight';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/FedraSansPro-Light.woff'),
        url('${props => props.endpoint}/static/fonts/FedraSansPro-Light.ttf');
    }
    
    @font-face {
        font-family: 'icomoon';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/icomoon.woff?hfqxn9'),
        url('${props => props.endpoint}/static/fonts/icomoon.svg?hfqxn9#icomoon'),
        url('${props => props.endpoint}/static/fonts/icomoon.ttf?hfqxn9');
    }
    
    @font-face {
        font-family: 'CoFoSansRegular';
        font-display: swap;
        src:
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.eot?#iefix') format('embedded-opentype'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.woff2') format('woff2'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.woff') format('woff'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'CoFoSansMedium';
        font-display: swap;
        src:
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.eot?#iefix') format('embedded-opentype'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.woff2') format('woff2'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.woff') format('woff'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'CoFoSansBold';
        font-display: swap;
        src:
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.eot?#iefix') format('embedded-opentype'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.woff2') format('woff2'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.woff') format('woff'),
            url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    body {
        font-family: "R1Custom", "CoFoSansRegular", Helvetica, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-rendering: optimizeLegibility;
    }
    
    * {
        box-sizing: border-box;
    }
    
    * a {
        color: ${COLORS.Link};
        text-decoration: none;
        font-family: 'R1Custom', 'CoFoSansRegular', Helvetica, sans-serif;
    }
    
    #root {
        white-space: pre-wrap;
    }
`;
